import React from "react";
import { Range, getTrackBackground } from "react-range";

const Filter = ({
                    selectedGender,
                    setSelectedGender,
                    selectedSpecialty,
                    setSelectedSpecialty,
                    selectedLanguage,
                    setSelectedLanguage,
                    selectedTelemedicine,
                    setSelectedTelemedicine,
                    selectedHouseCalls,
                    setSelectedHouseCalls,
                    selectedOnlineBooking,
                    setSelectedOnlineBooking,
                    selectedRating,
                    setSelectedRating,
                    range,
                    setRange,
                    onApplyGender,
                    onApplySpecialty,
                    onApplyLanguage,
                    onApplyRange
                }) => {
    const specialties = ["All", "Cardiology", "Pediatrics", "Dermatology"];
    const languages = ["All", "English", "Spanish", "Portuguese", "German", "French"];
    const yesNoAny = ["Any", "Yes", "No"];
    const ratingOptions = [1, 2, 3, 4, 5];

    const inputStyle = {
        borderRadius: "10px",
        border: "none",
        borderColor: "#ced4da",
        padding: "6px 12px",
        backgroundColor: "#f8f9fa",
        fontSize: "16px",
    };

    const getButtonStyle = isSelected => ({
        backgroundColor: isSelected ? "#f0f4ff" : "#fff",
        border: isSelected ? "none" : "1px solid #ced4da",
        color: isSelected ? "#007bff" : "#333",
        borderRadius: "10px",
        padding: "6px 12px",
        marginRight: "8px",
        marginBottom: "8px",
    });

    const SectionHeader = ({ title, isOpen, onClick }) => (
        <div
            className="d-flex align-items-center justify-content-between mb-2"
            style={{ cursor: "pointer" }}
            onClick={onClick}
        >
            <h6 style={{ margin: 0, fontSize: "20px" }}>{title}</h6>
            {isOpen
                ? <i className="bi bi-chevron-up" style={{ fontSize: "15px" }} />
                : <i className="bi bi-chevron-down" style={{ fontSize: "15px" }} />
            }
        </div>
    );

    const [availabilityOpen, setAvailabilityOpen] = React.useState(true);
    const [costInsuranceOpen, setCostInsuranceOpen] = React.useState(true);
    const [characteristicsOpen, setCharacteristicsOpen] = React.useState(true);
    const [patientPreferencesOpen, setPatientPreferencesOpen] = React.useState(true);

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="filtro"
            aria-labelledby="offcanvasRightLabel"
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasRightLabel">Filter</h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>

            <div className="offcanvas-body">
                {/* Availability */}
                <div className="mb-4">
                    <SectionHeader
                        title="Availability"
                        isOpen={availabilityOpen}
                        onClick={() => setAvailabilityOpen(!availabilityOpen)}
                    />
                    {availabilityOpen && (
                        <div className="mt-3">
                            <div className="mb-3">
                                <label className="mb-1">Availability Days</label>
                                <select className="form-select" defaultValue="" style={inputStyle}>
                                    <option value="" disabled hidden>Select</option>
                                    <option>Monday</option>
                                    <option>Tuesday</option>
                                    <option>Wednesday</option>
                                    <option>Thursday</option>
                                    <option>Friday</option>
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="mb-1">Availability Time</label>
                                <select className="form-select" defaultValue="" style={inputStyle}>
                                    <option value="" disabled hidden>Select</option>
                                    <option>9:00</option>
                                    <option>10:00</option>
                                </select>
                            </div>
                        </div>
                    )}
                </div>

                {/* Cost & Insurance */}
                <div className="mb-4">
                    <SectionHeader
                        title="Cost and Insurance"
                        isOpen={costInsuranceOpen}
                        onClick={() => setCostInsuranceOpen(!costInsuranceOpen)}
                    />
                    {costInsuranceOpen && (
                        <div className="mt-3">
                            <div className="mb-3">
                                <label className="mb-1">Fee Range</label>
                                <div className="d-flex justify-content-between">
                                    <span>€{range[0]}</span>
                                    <span>€{range[1]}</span>
                                </div>
                                <div style={{ margin: "20px 0" }}>
                                    <Range
                                        step={1}
                                        min={0}
                                        max={4000}
                                        values={range}
                                        onChange={setRange}
                                        renderTrack={({ props, children }) => (
                                            <div
                                                {...props}
                                                style={{
                                                    ...props.style,
                                                    height: "6px",
                                                    width: "100%",
                                                    borderRadius: "4px",
                                                    background: getTrackBackground({
                                                        values: range,
                                                        colors: ["#ccc", "#007bff", "#ccc"],
                                                        min: 0,
                                                        max: 4000,
                                                    }),
                                                }}
                                            >
                                                {children}
                                            </div>
                                        )}
                                        renderThumb={({ props }) => (
                                            <div
                                                {...props}
                                                style={{
                                                    ...props.style,
                                                    height: "20px",
                                                    width: "20px",
                                                    backgroundColor: "#fff",
                                                    border: "2px solid #007bff",
                                                    borderRadius: "50%",
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Characteristics */}
                <div className="mb-4">
                    <SectionHeader
                        title="Characteristics"
                        isOpen={characteristicsOpen}
                        onClick={() => setCharacteristicsOpen(!characteristicsOpen)}
                    />
                    {characteristicsOpen && (
                        <div className="mt-3">
                            <div className="mb-3">
                                <label className="mb-1">Specialty</label>
                                <div>
                                    {specialties.map(spec => (
                                        <button
                                            key={spec}
                                            onClick={() => setSelectedSpecialty(spec)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedSpecialty === spec)}
                                        >
                                            {spec}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="mb-1">Gender</label>
                                <select
                                    className="form-select"
                                    value={selectedGender}
                                    onChange={e => setSelectedGender(e.target.value)}
                                    style={inputStyle}
                                >
                                    <option value="All">All</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                        </div>
                    )}
                </div>

                {/* Patient Preferences */}
                <div className="mb-4">
                    <SectionHeader
                        title="Patient Preferences"
                        isOpen={patientPreferencesOpen}
                        onClick={() => setPatientPreferencesOpen(!patientPreferencesOpen)}
                    />
                    {patientPreferencesOpen && (
                        <div className="mt-3">
                            <div className="mb-3">
                                <label className="mb-1">Language</label>
                                <div>
                                    {languages.map(lang => (
                                        <button
                                            key={lang}
                                            onClick={() => setSelectedLanguage(lang)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedLanguage === lang)}
                                        >
                                            {lang}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="mb-1">Telemedicine Available</label>
                                <div>
                                    {yesNoAny.map(opt => (
                                        <button
                                            key={opt}
                                            onClick={() => setSelectedTelemedicine(opt)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedTelemedicine === opt)}
                                        >
                                            {opt}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="mb-1">House Calls Available</label>
                                <div>
                                    {yesNoAny.map(opt => (
                                        <button
                                            key={opt}
                                            onClick={() => setSelectedHouseCalls(opt)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedHouseCalls === opt)}
                                        >
                                            {opt}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="mb-1">Online Booking</label>
                                <div>
                                    {yesNoAny.map(opt => (
                                        <button
                                            key={opt}
                                            onClick={() => setSelectedOnlineBooking(opt)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedOnlineBooking === opt)}
                                        >
                                            {opt}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className="mb-1">Rating</label>
                                <div>
                                    {ratingOptions.map(starCount => (
                                        <button
                                            key={starCount}
                                            onClick={() => setSelectedRating(starCount)}
                                            className="btn btn-sm"
                                            style={getButtonStyle(selectedRating === starCount)}
                                        >
                                            {[...Array(starCount)].map((_, i) => (
                                                <i key={i} className="bi bi-star-fill text-danger me-1" />
                                            ))}
                                            &nbsp;Up
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="p-3 d-flex justify-content-between">
                <button
                    type="button"
                    className="btn btn-outline-primary rounded-3 px-3"
                    data-bs-dismiss="offcanvas"
                    onClick={() => {
                        setSelectedGender("All");
                        setSelectedSpecialty("All");
                        setSelectedLanguage("All");
                        setSelectedTelemedicine("Any");
                        setSelectedHouseCalls("Any");
                        setSelectedOnlineBooking("Any");
                        setSelectedRating("");
                        setRange([0, 4000]);
                        onApplyGender("All");
                        onApplySpecialty("All");
                        onApplyLanguage("All");
                        onApplyRange([0, 4000]);
                    }}
                >
                    Clear
                </button>
                <button
                    type="button"
                    className="btn btn-primary rounded-3 px-3"
                    data-bs-dismiss="offcanvas"
                    onClick={() => {
                        onApplyGender(selectedGender);
                        onApplySpecialty(selectedSpecialty);
                        onApplyLanguage(selectedLanguage);
                        onApplyRange(range);
                    }}
                >
                    Apply
                </button>
            </div>
        </div>
    );
};

export default Filter;
